






















import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfFinanceCapitalExpenseRecord",
  components: { AuditTabPane },
})
export default class AuditTabOfFinanceCapitalExpenseRecord extends Vue {
  get fetchData() {
    return api.capitalExpenseRecord.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "expenseRecordDetail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
